import { CRUD } from "@/shared/components";
import { StreamEntrypointsListQuery } from "@/admin/entities/streamEntrypoints";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
  getTableData,
  mapColumns,
  StreamEntrypointsSchemas,
  type StreamEntrypointRow,
} from "../model";
import { StreamEntrypointShow } from "..";

/**
 * Реестр точек входа: только чтение — ни создания, ни редактирования, ни
 * удаления. Точка заводится партнёром вместе с live input в Cloudflare.
 */
export function StreamEntrypoints() {
  return (
    <CRUD<StreamEntrypointRow>
      listQuery={StreamEntrypointsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={getColumnsConfig()}
      filterSchema={StreamEntrypointsSchemas.filterSchema}
      editSchema={{
        ...StreamEntrypointsSchemas.editSchema,
        details: {
          ...StreamEntrypointsSchemas.editSchema.details,
          showComponent: StreamEntrypointShow,
        },
      }}
      texts={getTextsConfig()}
      persistFilters
      useMobileView
      mobileColumns={getMobileColumnsConfig()}
    />
  );
}
